import { render, staticRenderFns } from "./PisWarning.vue?vue&type=template&id=44a147b5&scoped=true"
import script from "./PisWarning.vue?vue&type=script&lang=js"
export * from "./PisWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a147b5",
  null
  
)

export default component.exports